import '../styles/index.scss';

$(document).ready(() => {
    var urlParams = new URLSearchParams(window.location.search);
    var accountGuid = urlParams.get('a');
    var emailAddressGuid = urlParams.get('e');
    var server = urlParams.get('g');

    var url = `https://${server}.embercrm.com/api/PatronConsent/${accountGuid}/${emailAddressGuid}`;
    //var url = `http://192.168.100.37:45455/api/PatronConsent/${accountGuid}/${emailAddressGuid}`;

    function getData() {
        $.getJSON(url, (data) => {
            $('#emailAddress').text(data.emailAddress);
            $('#userDisplayName').text(data.userDisplayName);

            if (data.locationName) {
                $('#location').text(data.locationName + ', ' + data.locationAddress);
            } else {
                $('#location').parent().remove();
            }
        })
        .fail(() => showError())
        .always(() => { $('body').addClass('visible'); });
    }

    function showError() {
        $('#contentContainer').hide();
        $('#buttonContainer').hide();
        $('#apiErrorMessage').removeClass('d-none');
    }

    function showSuccess() {
        $('#contentContainer').hide();
        $('#buttonContainer').hide();
        $('#apiSuccessMessage').removeClass('d-none');
    }

    window.patchEmailAddress = (action) => {
        $.ajax({
            type: 'PATCH',
            url: url,
            data: JSON.stringify({ action: action }),
            contentType: 'application/json'
        })
        .done(() => showSuccess())
        .fail(() => showError());
    };

    getData();
});